import styled from 'styled-components'
import Icon from 'uiComponents/atoms/Icon/Icon'

export const DropDetailsScrollDownIcon = styled(Icon)`
  position: absolute;
  bottom: 18px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 66px;
  height: 33px;
`
